import React, { Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import Snackbar from '../components/snackbar/snackbar.component';
import Layout from '../hoc/layout/layout';
import { HIDE_SNACKBAR } from '../store/action-types';
import { RootState } from '../store/reducers';

const MeetContainer = React.lazy(
  () => import('./meet/container/meet.container'),
);

const MeetEndOwner = React.lazy(
  () => import('./meet-end/container/meet-end-owner.container'),
);

const MeetEndContainer = React.lazy(
  () => import('./meet-end/container/meet-end.container'),
);

const AuthContainer = React.lazy(
  () => import('./auth/container/auth.container'),
);

const AppRoutes: React.FC = (props) => {
  const dispatch = useDispatch();
  const { snackbar } = useSelector((state: RootState) => state.common);

  const routes = [
    {
      path: '/:id',
      component: AuthContainer,
      exact: true,
      index: 0,
      isPrivate: false,
    },
    {
      path: '/:id/meet',
      component: MeetContainer,
      exact: true,
      index: 1,
      isPrivate: true,
    },
    {
      path: '/:id/meet-end',
      component: MeetEndOwner,
      exact: true,
      index: 2,
      isPrivate: true,
    },
    {
      path: '/:id/end',
      component: MeetEndContainer,
      exact: true,
      index: 3,
      isPrivate: true,
    },
  ];

  const renderRoutes = () =>
    routes.map((route) => {
      const RouteComponent = route.component;

      return (
        <Route
          key={route.index}
          path={route.path}
          render={(renderProps) => (
            <RouteComponent {...props} {...renderProps} />
          )}
          exact={route.exact}
        />
      );
    });

  return (
    <Layout>
      <Snackbar
        {...snackbar}
        handleClose={() => dispatch({ type: HIDE_SNACKBAR, payload: snackbar })}
      />
      <Suspense fallback={<div> Loading.. </div>}>
        <Switch>
          {renderRoutes()}
          {/* <Route
            render={(renderProps) => <NotFound {...props} {...renderProps} />}
          /> */}
        </Switch>
      </Suspense>
    </Layout>
  );
};

export default AppRoutes;
